import Page2022 from './Page2022';
export default Page2022;
